module.exports = __webpack_public_path__ + "img/sceneIcon4-5.0a4e0d95.png";